import { render } from "./ConfirmOrder.vue?vue&type=template&id=f7bf8922&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=f7bf8922&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7bf8922"]])

export default __exports__